import { NAPSTER_BRAND } from '../brands'

// Brand is now a constant - Napster only
export const useBrand = () => NAPSTER_BRAND
